module.exports = __webpack_public_path__ + "static/background-3-0cec4e3b5bd72f4ccfa857bcbd7391fe.png";